import { useMemo, useState } from 'react';
import useDebounce from './use-debounce';

type Option = {
  debounceTimeout: number;
  minCharacter?: number;
};
const useDebouncedValue = (
  initialValue = '',
  options: Option = { debounceTimeout: 1000 },
): [
  string,
  {
    onChange: (text: string) => void;
  },
] => {
  const [value, setValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(value);

  const handlers = useMemo(
    () => ({
      onChange: (text: string) => setValue(text),
    }),
    [],
  );

  useDebounce(
    () => {
      if (
        !options.minCharacter ||
        (options.minCharacter && value.length >= options.minCharacter)
      ) {
        setDebouncedValue(value);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value],
    options.debounceTimeout,
  );

  return [debouncedValue, handlers];
};

export default useDebouncedValue;
